export const actionTypes = {
  TABS_STATUS_REQUEST_START: 'USER_INCOMES.TABS_STATUS.REQUEST_START',
  TABS_STATUS_REQUEST_SUCCESS: 'USER_INCOMES.TABS_STATUS.REQUEST_SUCCESS',
  TABS_STATUS_REQUEST_FAILURE: 'USER_INCOMES.TABS_STATUS.REQUEST_FAILURE',
  TABS_STATUS_CHANGE_FILTER_VALUE: 'USER_INCOMES.TABS_STATUS.CHANGE_FILTER_VALUE',
};

export function startRequest() {
  return {
    type: actionTypes.TABS_STATUS_REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.TABS_STATUS_REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.TABS_STATUS_REQUEST_FAILURE,
    payload: error,
  };
}

export function changeFilterValue(value) {
  return {
    type: actionTypes.TABS_STATUS_CHANGE_FILTER_VALUE,
    payload: value,
  };
}
